import { render, staticRenderFns } from "./BrowserRestrict.vue?vue&type=template&id=61d9a21e&scoped=true"
import script from "./BrowserRestrict.vue?vue&type=script&lang=js"
export * from "./BrowserRestrict.vue?vue&type=script&lang=js"
import style0 from "./BrowserRestrict.vue?vue&type=style&index=0&id=61d9a21e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d9a21e",
  null
  
)

export default component.exports